import React, { useEffect, useState } from 'react';
import { apiStatus, subscribeApiStatus } from '../../services/api';

export default function ApiStatus() {
  const [messages, setMessages] = useState(apiStatus);
  useEffect(() => subscribeApiStatus(() => setMessages(apiStatus())), []);
  if (!messages.length) return null;
  return <div role="status" aria-live="polite" className="mb-4 p-3 border rounded bg-amber-50">
    {messages.map(message => <p key={message}>{message}</p>)}
  </div>;
}
